"use client";

import { usePathname } from "next/navigation";
import React, { createContext, useState, ReactNode, useCallback } from "react";
interface PageMetadata {
  title: string;
  path?: string;
}
interface PageMetadataContextType {
  metadata: Record<string, PageMetadata[]>;
  setMetadata: (newMetadata: PageMetadata[]) => void;
}
const defaultState: PageMetadataContextType = {
  metadata: {},
  setMetadata: () => {}
};
const PageMetadataContext = createContext<PageMetadataContextType>(defaultState);
export const PageMetadataProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const currentPath = usePathname();
  const [metadata, setMetadataInner] = useState<Record<string, PageMetadata[]>>({});
  const setMetadata = useCallback((newMetadata: PageMetadata[]) => {
    setMetadataInner({
      [currentPath]: newMetadata
    });
  }, [setMetadataInner, currentPath]);
  const value = {
    metadata,
    setMetadata
  };
  return <PageMetadataContext.Provider value={value} data-sentry-element="unknown" data-sentry-component="PageMetadataProvider" data-sentry-source-file="PageMetadataContext.tsx">{children}</PageMetadataContext.Provider>;
};
export default PageMetadataContext;